import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./HomePage.css"; 


const HomePage = () => {
  const slides = [
    
    {
      image: '/images/Untitled-1.png',
      link: "https://www.facebook.com/share/1FtNSJquyo/"
    },
    {
      image: '/images/Untitled-2.png',
     // headline: "Periyar Screens Youtube",
      link: "https://youtube.com/@periyarscreen?si=q_PpOLiNAXPMhe5A"
    },
    {
      image: '/images/Untitled-3.png',
    //  headline: "Instagram",
      link: "https://www.instagram.com/periyar_writings?utm_source=qr&igsh=eDJ1ZXM0Z2YzNDZw"
    },
    {
      image: '/images/Untitled-4.png',
    //  headline: "Kaattraaru.",
      link: "https://periyarbooks.com/collections/kaattaaru"
    }
  ];

  const carouselSettings = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true
  };

  return (
    <div className="home-container">
      <div className="home-carousel">
        <Slider {...carouselSettings}>
          {slides.map((slide, idx) => (
            <div key={idx} className="carousel-slide">
              {slide.link.startsWith('http') ? (
                <a href={slide.link} target="_blank" rel="noopener noreferrer">
                  <img src={slide.image} alt={slide.headline} className="carousel-image" />
                </a>
              ) : (
                <Link to={slide.link}>
                  <img src={slide.image} alt={slide.headline} className="carousel-image" />
                </Link>
              )}
              <div className="carousel-caption">
                <h2>{slide.headline}</h2>
                <p>{slide.excerpt}</p>
                {slide.link.startsWith('http') ? (
                  <a className="carousel-btn" href={slide.link} target="_blank" rel="noopener noreferrer">Go</a>
                ) : (
                  <Link className="carousel-btn" to={slide.link}>Go</Link>
                )}
              </div>
            </div>
          ))}
        </Slider>
      </div>

    </div>
  );
};

export default HomePage;
